<template>
    <tailwind-layout title="Questions">
        <div class="px-4 py-5 bg-white bg-rent-risk-blue-100 overflow-hidden sm:rounded-lg">
            <div class="relative max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                <h4 class="text-3xl text-center font-bold leading-7 text-gray-700 sm:text-2xl sm:truncate">
                    Questions
                </h4>
                <div class="grid grid-cols-2 gap-2">
                    <div>
                        <form @submit.prevent="store" class="space-y-8 divide-y divide-gray-200">
                            <input type="hidden" id="user_prefs" name="user_prefs"> <input type="hidden" id="user_prefs2" name="user_prefs2">
                            <div class="space-y-8 divide-y divide-gray-200">
                                <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                    <div v-for="(question, index) in questions" class="sm:col-span-6">
                                        <p class="leading-5">{{ (index+1)+'. '+question.questionText }}</p>
                                        <fieldset class="mt-4 ml-4">
                                            <div class="space-y-4">
                                                <div v-for="(option, choiceId) in question.questionSelect.questionChoice" :key="'question'+index+'-'+(choiceId+1)" class="flex items-center">
                                                    <input :id="'question'+index+'-'+(choiceId+1)" :name="'question'+(index+1)" v-bind:value="(choiceId+1)" v-on:click="updateAnswer(index, (choiceId+1))" type="radio" class="focus:ring-rent-risk-blue-400 h-4 w-4 text-rent-risk-blue-400 border-gray-300" />
                                                    <label :for="'question'+index+'-'+(choiceId+1)" class="ml-3 block text-sm font-medium text-gray-700">
                                                        {{ option }}
                                                    </label>
                                                </div>
                                                <p v-if="index === 0" v-text="form.errors.question1" class="text-red-500 text-sm"></p>
                                                <p v-if="index === 1" v-text="form.errors.question2" class="text-red-500 text-sm"></p>
                                                <p v-if="index === 2" v-text="form.errors.question3" class="text-red-500 text-sm"></p>
                                                <p v-if="index === 3" v-text="form.errors.question4" class="text-red-500 text-sm"></p>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-5 grid grid-cols-6 gap-4">
                                <div class="col-end-7 col-span-2 justify-end flex">
                                    <inertia-link :href="route('agent.landlord-verification')" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">Cancel</inertia-link>
                                    <form-button :form="form" type="submit">
                                        Save
                                    </form-button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </tailwind-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import SelectInput from "@/Shared/SelectInput.vue"

export default {
    components: {
        Icon,
        TailwindLayout,
        FormButton,
        LoadingButton,
        SelectInput,
    },
    props: {
        states: Object,
        questions: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                question1: this.question1,
                question2: this.question2,
                question3: this.question3,
                question4: this.question4,
                user_prefs: null,
                user_prefs2: null,
            })
        }
    },
    methods: {
        store() {
            this.form.user_prefs = adx.validate('user_prefs');
            this.form.user_prefs2 = adx.validate('user_prefs2');
            this.form.post(this.route('agent.questions.submit'))
        },
        updateAnswer(question, answer) {
            if((question+1) === 1) {
                this.form.question1 = answer
            }
            else if((question+1) === 2) {
                this.form.question2 = answer
            }
            else if((question+1) === 3) {
                this.form.question3 = answer
            }
            else if((question+1) === 4) {
                this.form.question4 = answer
            }
        },
    }
}
</script>
